import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getTeamsMembers } from "../../../Logic/EmsAPI/Teams";
import { getLastTouched, saveLastTouched } from "../../../Logic/LastTouched/misc";
import { RootState } from "../../../state/store";
import { getSessionValue } from "../../../utilities/localStore/calls";
import GenericCalendar from "../../Generic/Calendar";
import FindDropdown from "../../Generic/FindDropdown";

function Calendar() {
    const User = useSelector((state: RootState) => state.UserInformation);
    const [userList, setUserList] = useState<{ name: string; id: number }[]>([]);
    const [teamMember, setTeamMember] = useState<{ name: string; id: number }>({ name: "", id: 0 });
    useEffect(() => {
        (async () => {
            try {
                const iLastTouched = getLastTouched();
                let myTeamsUserList: { name: string; id: number }[] | null = getSessionValue("myTeamsUserList");
                if (myTeamsUserList == null) {
                    myTeamsUserList = await getTeamsMembers();
                }
                setTeamMember(
                    myTeamsUserList!.find(u => u.id === iLastTouched.MyTeams.CalendarUserId) || {
                        name: "Select a user",
                        id: 0,
                    },
                );
                setUserList(myTeamsUserList ?? []);
            } catch (error) {
                console.error(error);
            }
        })();
    }, []);
    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <div
                className="secondRow Row"
                style={{ flex: "0 0 37px" }}
            >
                <div className="col-xs-2">
                    <div
                        className="enquiries-tabs"
                        style={{ padding: "10px 0px 0px 9px" }}
                    >
                        <FindDropdown
                            id={0}
                            label={teamMember.name}
                        >
                            {userList.map(user => (
                                <li key={user.id}>
                                    <button
                                        title={user.name}
                                        onClick={async () => {
                                            let iLastTouched = getLastTouched();
                                            iLastTouched.MyTeams.CalendarUserId = user.id;
                                            saveLastTouched(iLastTouched);
                                            setTeamMember(user);
                                            // Handle user selection
                                        }}
                                    >
                                        {user.name}
                                    </button>
                                </li>
                            ))}
                        </FindDropdown>
                    </div>{" "}
                </div>
            </div>
            <div style={{ flex: 1 }}>
                {teamMember.id > 0 && (
                    <GenericCalendar
                        userId={teamMember.id > 0 ? teamMember.id : 0}
                        canCaptureEvents={false}
                    />
                )}
            </div>
        </div>
    );
}

export default Calendar;
